<template>
    <div>
        <div v-show="value" ref="main" class="picker-panel">
            <transition name="fade">
                <div
                    class="mask"
                    ref="mask"
                    v-show="value"
                    @click="onCloseClick"
                    @touchmove.prevent="() => {}"
                ></div>
            </transition>
            <transition name="slide">
                <div class="panel" ref="panel" v-show="value">
                    <div class="title">
                        {{ title }}
                        <svg
                            class="close"
                            @click="onCloseClick"
                            width="40"
                            height="40"
                            viewBox="0 0 40 40"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                class="close-path"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M23.8499 25.125L14.8344 16.109L16.2486 14.6948L25.2641 23.7108L23.8499 25.125Z"
                            />
                            <path
                                class="close-path"
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M16.2487 25.1249L25.2647 16.1089L23.8505 14.6947L14.8345 23.7107L16.2487 25.1249Z"
                            />
                        </svg>
                    </div>
                    <div ref="content" class="content">
                        <slot></slot>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
export default {
    name: 'picker-panel',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            msg: '哈哈哈',
            isAppended: false,
        };
    },
    watch: {
        value() {
            if (!this.isAppended) {
                document.body.appendChild(this.$refs.main);
                this.isAppended = true;
            }
        },
    },
    methods: {
        async onClick() {
            this.msg = '呵呵呵';
        },
        onCloseClick() {
            if (this.$refs.content) {
                this.$refs.content.scrollTop = 0;
            }
            this.$emit('input', false);
        },
    },
};
</script>
<style lang="less" scoped>
.picker-panel {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9999;
    overflow: hidden;
    .mask {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #000;
        opacity: 0.3;
    }
    .panel {
        display: flex;
        position: absolute;
        flex-direction: column;
        bottom: 0;
        width: 100%;
        height: 70%;
        background: #f8f8f8;
        border-radius: 12px 12px 0 0;
    }
    .title {
        font-size: 18px;
        height: 56px;
        line-height: 56px;
        box-sizing: border-box;
        position: relative;
        text-align: center;
        font-weight: 500;
        .close {
            position: absolute;
            top: 12px;
            right: 12px;
            width: 40px;
            height: 40px;

            .close-path {
                fill: #222;
            }
        }
    }
    .content {
        flex: 1;
        overflow: auto;
        width: 100%;
        padding-bottom: env(safe-area-inset-bottom);
    }

    // fade
    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.3s;
    }
    .fade-enter,
    .fade-leave-to,
    .fade-leave-active {
        opacity: 0;
    }

    .slide-enter-active,
    .slide-leave-active {
        transition: transform 0.3s cubic-bezier(0.25, 0.1, 0.25, 1);
    }
    .slide-enter,
    .slide-leave-to {
        transform: translate3D(0, 100%, 0);
    }
}
</style>
